const { MINUTE_MS } = require('../../time');

const UPDATE_CAMPAIGN_STATE_CHANGE_TIMESTAMP_ACTION =
  'UPDATE_CAMPAIGN_STATE_CHANGE_TIMESTAMP_ACTION';

// We use this to minimize the chance that the user sees a campaign image/tooltip,
// and then it becomes inactive during their payment process.
const FRONTEND_CAMPAIGN_END_BUFFER = 5 * MINUTE_MS;

const IMAGE_TEMPLATE_FIELDS = [
  'mainBanner',
  'mainBannerBlurred',
  'detailBanner',
  'bundleImage',
  'bundleImageTexture',
  'cardBackImageTexture',
  'bannerImage',
  'bannerImage',
  'bannerImageIOS',
  'bannerDetailImage',
];

module.exports = {
  UPDATE_CAMPAIGN_STATE_CHANGE_TIMESTAMP_ACTION,
  FRONTEND_CAMPAIGN_END_BUFFER,
  IMAGE_TEMPLATE_FIELDS,
};
